/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { ssoService } from '../../api/services/ssoService';
import { user_login, user_logout } from '../../infra/aggregates/authSlice';
import {
  removeAuthToken,
  setAuthToken,
} from '../../infra/aggregates/authTokenSlice';
import { useAppDispatch } from '../../infra/hooks';
import AuthInterface from '../../infra/aggregates/AuthInterface';

import { useNavigate } from 'react-router-dom';
import { setLoading } from '../../infra/aggregates/LoaderSlice';
import { setHRView } from '../../infra/aggregates/myProfile/isHRViewSlice';
import { commonServices } from '../../api/services/commonServices';
import { setUserProfilePic } from '../../infra/aggregates/profilePicSlice';
const DTOResetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  async function callSSO(empId: number, token: any) {
    dispatch(setLoading(true));
    if (token) {
      await ssoService
        .gotoEmployee(empId)
        .then((response: any) => {
          if (response) {
            const user_obj: AuthInterface = {
              user_id: response?.user?.id,
              name: response?.employee?.first_name,
              username: response?.user?.username,
              profile_pic: response?.user?.profile_pic,
              email: response?.user?.email,
              status: response?.user?.status,
              company_id: response.company,
              designaion: response.designation?.name,
              department: response.department?.name,
              emp_id: response.employee?.id,
              department_id: response.department?.id,
              staff_id: response?.employee?.staff_id,
              hire_date: response?.employee?.emp_job_detail?.hire_date,
              currency: response?.currency?.name,
            };
            dispatch(user_login(user_obj));
            dispatch(setAuthToken(true));
            if (response?.user?.id) {
              commonServices
                .getFullPathProfilePic(response?.user?.id)
                .then((getProfilePic: any) => {
                  if (getProfilePic?.response == 'success') {
                    dispatch(
                      setUserProfilePic(getProfilePic?.data?.profile_pic),
                    );
                  }
                });
            }

            navigate({
              pathname: '/employeePersonalDetails',
            });

            dispatch(setLoading(false));
          } else {
            dispatch(setLoading(false));
            return;
          }
        })
        .catch((err) => {
          dispatch(setLoading(false));
          console.log(err);
        });
    } else {
      navigate({ pathname: '/login' });
    }
  }
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const emp_id = urlParams.get('id');
    const _getToken = urlParams.get('token');
    const _getPortal = urlParams.get('portal');

    //SSO Implementation

    if (_getPortal == 'false') {
      dispatch(setHRView(true));
    } else {
      dispatch(setHRView(false));
    }
    if (emp_id) {
      dispatch(user_logout());
      dispatch(removeAuthToken());
      localStorage.clear();
      callSSO(Number(emp_id), _getToken);
    }
  }, []);
  return <></>;
};

export default DTOResetPassword;
